import React from 'react'

import Billboard from '../../components/billboard'
import Header from '../../components/header'
import Shelf from '../../components/shelf'
import titles from '../../../common/assets/titles.json'
import { arrayShuffle } from '../../../common/lib/array-functions'

export default () => {
	return (
		<React.Fragment>
			<Header />
			<Billboard title={titles[0]} />
			<div style={{ height: '24px' }} />
			<Shelf header="Full-Length Videos" titles={arrayShuffle(titles)} />
			<Shelf header="Parts" titles={arrayShuffle(titles)} />
			<Shelf header="Contests" titles={arrayShuffle(titles)} />
			<Shelf header="Shows" titles={arrayShuffle(titles)} />
			<Shelf header="Documentaries" titles={arrayShuffle(titles)} />
			<Shelf header="Shop & Homie Videos" titles={arrayShuffle(titles)} />
			<Shelf header="Tours" titles={arrayShuffle(titles)} />
			<div style={{ height: '64px' }} />
			<div>
				<div className="u-width-wrap">
					<p style={{ fontSize: '10px', color: '#888' }}>&copy; 2018 5FORTY</p>
				</div>
			</div>
			<div style={{ height: '24px' }} />
		</React.Fragment>
	)
}


// WEBPACK FOOTER //
// ./src/mobile/pages/browse/index.js